<div class="{{styles.error}}" style="width: {{typeof props.width === 'number' ? props.width + 'px' : props.width}}"><span class="{{styles.error_content}}"><div>{{if state.errorImg}} <img src="{{state.errorImg}}"> {{/if}}<div class="{{styles.error_text}}">{{state.errorText || '出错了'}},<span class="{{styles.error_text_reload}}">点击重新加载</span></div></div></span></div>


// WEBPACK FOOTER //
// ./D:/project/issts/oy-search-component/src/components/OYFilter/error.art